/**
 * karmabooking-api
 *
 * @link      https://karmabunny.com.au
 * @copyright Copyright (c) 2020 Karmabunny
 */

if (!window.__translations) {
    console.warn("Missing window.__translations. Was it injected properly?");
    window.__translations = {
        lang: 'en',
        name: 'en',
        tr: {},
        plurals: {},
    };
}

if (!window.__config) {
    console.warn("Missing window.__config. Was it injected properly?");
    window.__config = {
        prefix: 'book',
        url: 'http://localhost:8080/kbapi',
        key: '',
        site: 'uninest',
        language_options: ['en'],
        environment: 'dev',
        registration_fee: 20000,
    }
}

if (!window.__marketing) {
    window.__marketing = {
        source: [],
        action: [],
    }
}
